import Api from "./Api";
import Csrf from "./Csrf";

export default {   
    
  async index() {
    await Csrf.getCookie();

    return Api.get("/logs");
  },
    
  async messageLogs(id) {
    await Csrf.getCookie();

    return Api.get("/logs/"+id+"/message");
  },
    
  async unplugLogs(id) {
    await Csrf.getCookie();

    return Api.get("/logs/"+id+"/unplug");
  },
    
  async reconnectLogs(id) {
    await Csrf.getCookie();

    return Api.get("/logs/"+id+"/reconnect");
  },
    
  async printLogs(id) {
    await Csrf.getCookie();

    return Api.get("/logs/"+id+"/print");
  },
    
  async temporaryReconnectLogs(id) {
    await Csrf.getCookie();

    return Api.get("/logs/"+id+"/temporary-reconnect");
  },
	
	async lockLogs(data){
		await Csrf.getCookie();

    return Api.post("/logs/locks",data);
	},

	async positionLogs(data){
		await Csrf.getCookie();

    return Api.post("/logs/positions",data);
	},

	async craneLogs(data){
		await Csrf.getCookie();

    return Api.post("/logs/cranes",data);
	},
	
	async filterLockLogs(data){
		await Csrf.getCookie();

    return Api.post("/logs/locks",data);
	},

  async taskHandovers(task_id){
    await Csrf.getCookie();

    return Api.get("/logs/task_handovers/" + task_id);
  }
	
};